var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-day",class:{
    'calendar-day--not-current': !_vm.day.isCurrentMonth,
    'calendar-day--today': _vm.isToday,
    'calendar-day--selected': _vm.isSelected,
    'calendar-day--past': _vm.isPast,
    'available' : !_vm.isPast&&(_vm.count>=1)&&!_vm.isToday&&!_vm.isSelected&&_vm.day.isCurrentMonth},on:{"click":function($event){return _vm.$emit('dateSelected')}}},[_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }